import $ from '../core/Dom';
import { scrollTo } from '../lib/helpers';

export default el => {
    const $el = $(el);

    const onClick = e => {
        e.preventDefault();

        const target = $('#articleContent').get(0);
        if (!target) {
            return;
        }

        scrollTo(target);
    };

    const init = () => {
        $el.on('click', onClick);
    };

    const destroy = () => {
        $el.off('click', onClick);
    };

    return {
        init,
        destroy
    };
};
